var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"selected-key":_vm.selectedKey,"selected-value":_vm.selectedValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }